import { ErrorClass } from "../error";

export class TimeError extends ErrorClass {
    constructor(name: string, message: string) {
        super(name, message);
    }
}
